// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__eDfN9","productName":"Table_productName__1GE19"};